import { useCallback, useMemo } from "react";
import { useHistory } from "react-router-dom";

import ViewerOnboardingModal from "./ViewerOnboardingModal";

import { useAuthUserQuery } from "modules/user/hooks/queries/useAuthUserQuery";
import { useSelectedProject } from "modules/projects/hooks/useSelectedProject";
import { useCompleteOnboardingMutation } from "modules/user/hooks/mutations/useCompleteOnboardingMutation";

import { UserRole } from "modules/user/types/entities";

import { insightsPrivateRoutesConstants } from "modules/insights/routes/private/routesConstants";

const OnboardingModal = () => {
  const { push } = useHistory();

  const { data: userData } = useAuthUserQuery();
  const { isSingleProject, selectedProject } = useSelectedProject();

  const { mutate: completeOnboarding, isLoading } =
    useCompleteOnboardingMutation();

  const onboardingType: UserRole | null = useMemo(() => {
    if (!userData) return null;

    const role = isSingleProject
      ? (selectedProject?.user_role?.[0] as UserRole)
      : userData.best_role;

    if (userData.onboarding[role]) return null;

    return role;
  }, [isSingleProject, selectedProject, userData]);

  const submitHandler = useCallback(() => {
    if (!onboardingType) return;

    completeOnboarding(
      { user_role: onboardingType },
      {
        onSuccess: () => {
          push(insightsPrivateRoutesConstants.query_engine.href("all"));
        }
      }
    );
  }, [completeOnboarding, onboardingType, push]);

  const onboardingTypeModal: Record<UserRole, JSX.Element> = useMemo(
    () => ({
      team_viewer: (
        <ViewerOnboardingModal onSubmit={submitHandler} isLoading={isLoading} />
      ),
      client_viewer: (
        <ViewerOnboardingModal onSubmit={submitHandler} isLoading={isLoading} />
      ),
      staff: <></>,
      client: <></>,
      administrator: <></>,
      master: <></>,
      executive: <></>,
      program_manager: <></>
    }),
    [submitHandler, isLoading]
  );

  if (!userData || !onboardingType) return null;

  return onboardingTypeModal[onboardingType];
};

export default OnboardingModal;
